export const industriesSortItems: string[] = [
  'Bestselling',
  'Newest',
  'cheapest',
  'Expensive',
];
